/**
 * Helpers for `<input type="datetime-local">`, whose value is always a wall-clock
 * string with no timezone.
 *
 * The app submits these by parsing them as browser-local time
 * (`new Date(value).toISOString()`), so prefilling has to render browser-local
 * too — formatting in Pacific here would shift the time every time a form was
 * reopened outside PT. Display, by contrast, stays Pacific via `formatDateTimePT`.
 */

function pad(n: number): string {
  return String(n).padStart(2, '0');
}

/** ISO instant -> "YYYY-MM-DDTHH:mm" in browser-local time, or '' when absent. */
export function isoToDateTimeLocal(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** "YYYY-MM-DDTHH:mm" (browser-local) -> ISO instant, or null when empty/invalid. */
export function dateTimeLocalToIso(value: string | null | undefined): string | null {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}
